"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-four/sections/aboutSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type AboutSection6sItem = {
    key: Key | null | undefined;
    /** Detected variants: "col-md-6" */
    className?: string;
    aboutListItems?: AboutSectionUlsItem[];
};

type AboutSectionUlsItem = {
    key: Key | null | undefined;
    /** Detected variants: "Transparent Communication" | "Child-friendly environment for visits" | "Compassionate care for childrens" | "Easy online and in-person consultation" */
    liText: ReactNode;
};
export type HomeFourAboutSectionGeneratedProps = {
    sectionDiv0Div0ClassName?: string;
    /** Default: "about" */
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/about-01.jpg" */
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "about" */
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/about-02.jpg" */
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "YEARS OF EXPERIENCE" */
    sectionDiv0Div0Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "12+" */
    sectionDiv0Div0Div0Div0H20Span0SpanText?: ReactNode;
    /** Default: "About Us" */
    sectionDiv0Div0Div1Div0Div0Div0DivText?: ReactNode;
    /** Default: "We Understand That Each Child Is Unique & Their" */
    sectionDiv0Div0Div1Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div1Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div1Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Health Journey." */
    sectionDiv0Div0Div1Div0Div0H20Span0SpanText?: ReactNode;
    /** Default: "We believe that every child deserves personalized, compassionate, and expert medical care. Our mission is to support your child’s growth, health, and happiness." */
    sectionDiv0Div0Div1Div0Div0P0PText?: ReactNode;
    /** Default: "0.2s" */
    sectionDiv0Div0Div1Div0Div1DivDataWowDelay?: string;
    /** Default: "1s" */
    sectionDiv0Div0Div1Div0Div1DivDataWowDuration?: string;
    /** Default: "mission" */
    sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/mission-01.svg" */
    sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Our Mission" */
    sectionDiv0Div0Div1Div0Div1Div1H30H3Text?: ReactNode;
    sectionDiv0Div0Div1Div0Div1Div1H30H3Visible?: boolean;
    sectionDiv0Div0Div1Div0Div1Div1H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div1Div1H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "To nurture healthy, happy, and confident children by combining medical excellence with empathy and understanding." */
    sectionDiv0Div0Div1Div0Div1Div1P0PText?: ReactNode;
    /** Default: "bg" */
    sectionDiv0Div0Div1Div0Div1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/mission-bg.png" */
    sectionDiv0Div0Div1Div0Div1ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div1Div0Div1ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div1Div0Div1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    sectionDiv0Div0Div1Div0Div2ClassName?: string;
    /** Default: "all_routes.aboutUs" */
    sectionDiv0Div0Div1Div0Link0LinkHref?: string;
    /** Default: "More About Us" */
    sectionDiv0Div0Div1Div0Link0LinkText?: ReactNode;
    sectionDiv0Div0Div1Div0Link0LinkVisible?: boolean;
    sectionDiv0Div0Div1Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "bg" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/about-bg-01.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/about-bg-02.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath2ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/about-bg-03.png" */
    sectionImageWithBasePath2ImageSrc?: string;
    sectionImageWithBasePath2ImageVisible?: boolean;
    sectionImageWithBasePath2ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    aboutSection6s: AboutSection6sItem[];
    aboutSection6sItemWrapper?: (item: AboutSection6sItem, content: ReactNode) => ReactNode;
    aboutSection6sRenderer?: (defaultNode: ReactNode) => ReactNode;
    aboutSectionUlsItemWrapper?: (item: AboutSectionUlsItem, content: ReactNode) => ReactNode;
    aboutSectionUlsRenderer?: (defaultNode: ReactNode) => ReactNode;
};

const HomeFourAboutSectionGenerated: FC<HomeFourAboutSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageAlt = "about",
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/about-01.jpg",
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageAlt = "about",
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/about-02.jpg",
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0Div0H20H2Text = "YEARS OF EXPERIENCE",
    sectionDiv0Div0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0Div0H20H2Props,
    sectionDiv0Div0Div0Div0H20Span0SpanText = "12+",
    sectionDiv0Div0Div1Div0Div0Div0DivText = "About Us",
    sectionDiv0Div0Div1Div0Div0H20H2Text = "We Understand That Each Child Is Unique & Their",
    sectionDiv0Div0Div1Div0Div0H20H2Visible,
    sectionDiv0Div0Div1Div0Div0H20H2Renderer,
    sectionDiv0Div0Div1Div0Div0H20H2Props,
    sectionDiv0Div0Div1Div0Div0H20Span0SpanText = "Health Journey.",
    sectionDiv0Div0Div1Div0Div0P0PText = "We believe that every child deserves personalized, compassionate, and expert medical care. Our mission is to support your child’s growth, health, and happiness.",
    sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageAlt = "mission",
    sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/mission-01.svg",
    sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div1Div0Div1Div1H30H3Text = "Our Mission",
    sectionDiv0Div0Div1Div0Div1Div1H30H3Visible,
    sectionDiv0Div0Div1Div0Div1Div1H30H3Renderer,
    sectionDiv0Div0Div1Div0Div1Div1H30H3Props,
    sectionDiv0Div0Div1Div0Div1Div1P0PText = "To nurture healthy, happy, and confident children by combining medical excellence with empathy and understanding.",
    sectionDiv0Div0Div1Div0Div1DivDataWowDelay = "0.2s",
    sectionDiv0Div0Div1Div0Div1DivDataWowDuration = "1s",
    sectionDiv0Div0Div1Div0Div1ImageWithBasePath0ImageAlt = "bg",
    sectionDiv0Div0Div1Div0Div1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/mission-bg.png",
    sectionDiv0Div0Div1Div0Div1ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div1Div0Div1ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div1Div0Div1ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div1Div0Link0LinkHref = "all_routes.aboutUs",
    sectionDiv0Div0Div1Div0Link0LinkText = "More About Us",
    sectionDiv0Div0Div1Div0Link0LinkVisible,
    sectionDiv0Div0Div1Div0Link0LinkRenderer,
    sectionDiv0Div0Div1Div0Link0LinkProps,
    sectionImageWithBasePath0ImageAlt = "bg",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/about-bg-01.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "bg",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/about-bg-02.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    sectionImageWithBasePath2ImageAlt = "bg",
    sectionImageWithBasePath2ImageSrc = "/Templates/Doccure/img/bg/about-bg-03.png",
    sectionImageWithBasePath2ImageVisible,
    sectionImageWithBasePath2ImageRenderer,
    sectionImageWithBasePath2ImageProps,
    sectionDiv0Div0ClassName,
    sectionDiv0Div0Div1Div0Div2ClassName,
    aboutSection6s,
    aboutSection6sItemWrapper,
    aboutSection6sRenderer,
    aboutSectionUlsItemWrapper,
    aboutSectionUlsRenderer,
}) => {
    return (
        <section className="about-section-four section">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row align-items-center"}>
                    <div className="col-lg-6">
                        <div className="about-img-four">
                            <div className="about-img-01">
                                {renderNode(sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageSrc} className="img-fluid" alt={sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageAlt} {...(sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                            </div>
                            <div className="about-img-02">
                                {renderNode(sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageSrc} className="img-fluid" alt={sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageAlt} {...(sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                            </div>
                            {renderNode(sectionDiv0Div0Div0Div0H20H2Visible, sectionDiv0Div0Div0Div0H20H2Renderer, (
                                <h2 {...(sectionDiv0Div0Div0Div0H20H2Props ?? {})}>
                                    <span>{sectionDiv0Div0Div0Div0H20Span0SpanText}</span>
                                    {sectionDiv0Div0Div0Div0H20H2Text}
                                </h2>
                            ))}
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="about-content-four">
                            <div className="section-header section-header-four section-white">
                                <div className="section-sub-title">{sectionDiv0Div0Div1Div0Div0Div0DivText}</div>
                                {renderNode(sectionDiv0Div0Div1Div0Div0H20H2Visible, sectionDiv0Div0Div1Div0Div0H20H2Renderer, (
                                    <h2 className="section-title" {...(sectionDiv0Div0Div1Div0Div0H20H2Props ?? {})}>
                                        {sectionDiv0Div0Div1Div0Div0H20H2Text}
                                        {" "}
                                        <span className="text-secondary">{sectionDiv0Div0Div1Div0Div0H20Span0SpanText}</span>
                                    </h2>
                                ))}
                                <p>{sectionDiv0Div0Div1Div0Div0P0PText}</p>
                            </div>
                            <div className="mission-item-four wow fadeInUp" data-wow-delay={sectionDiv0Div0Div1Div0Div1DivDataWowDelay} data-wow-duration={sectionDiv0Div0Div1Div0Div1DivDataWowDuration}>
                                <div className="mission-icon">
                                    {renderNode(sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageRenderer, (
                                        <SmartImage src={sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageAlt} className="img-fluid" {...(sectionDiv0Div0Div1Div0Div1Div0ImageWithBasePath0ImageProps ?? {})} />
                                    ))}
                                </div>
                                <div>
                                    {renderNode(sectionDiv0Div0Div1Div0Div1Div1H30H3Visible, sectionDiv0Div0Div1Div0Div1Div1H30H3Renderer, (
                                        <h3 className="custom-title" {...(sectionDiv0Div0Div1Div0Div1Div1H30H3Props ?? {})}>{sectionDiv0Div0Div1Div0Div1Div1H30H3Text}</h3>
                                    ))}
                                    <p>{sectionDiv0Div0Div1Div0Div1Div1P0PText}</p>
                                </div>
                                {renderNode(sectionDiv0Div0Div1Div0Div1ImageWithBasePath0ImageVisible, sectionDiv0Div0Div1Div0Div1ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div0Div1Div0Div1ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div1Div0Div1ImageWithBasePath0ImageAlt} className="mission-bg" {...(sectionDiv0Div0Div1Div0Div1ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                            </div>
                            <div className={sectionDiv0Div0Div1Div0Div2ClassName ?? "row g-3"}>
                                {renderCollectionNode(
                                    aboutSection6s,
                                    (item: AboutSection6sItem) => (
                                        <div className={item.className ?? "col-md-6"} key={item.key}>
                                            <ul className="about-list">
                                                {renderCollectionNode(
                                                    item.aboutListItems ?? [],
                                                    (item: AboutSectionUlsItem) => (
                                                        <li key={item.key}>{item.liText}</li>
                                                    ),
                                                    aboutSectionUlsItemWrapper,
                                                    aboutSectionUlsRenderer
                                                )}
                                            </ul>
                                        </div>
                                    ),
                                    aboutSection6sItemWrapper,
                                    aboutSection6sRenderer
                                )}
                            </div>
                            {renderNode(sectionDiv0Div0Div1Div0Link0LinkVisible, sectionDiv0Div0Div1Div0Link0LinkRenderer, (
                                <SmartLink href={sectionDiv0Div0Div1Div0Link0LinkHref} className="btn btn-white" {...(sectionDiv0Div0Div1Div0Link0LinkProps ?? {})}>
                                    {sectionDiv0Div0Div1Div0Link0LinkText}
                                    <i className="isax isax-arrow-right-1 ms-2" />
                                </SmartLink>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="about-bg-01" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="about-bg-02" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath2ImageVisible, sectionImageWithBasePath2ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath2ImageSrc} alt={sectionImageWithBasePath2ImageAlt} className="about-bg-03" {...(sectionImageWithBasePath2ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeFourAboutSectionGenerated;
